// extracted by mini-css-extract-plugin
export default {"root":"Gs0oXs","OverlineMenuButtonNSkin":"pr7XQM","overlineMenuButtonNSkin":"pr7XQM","linkElement":"rcIF9K","gapper":"nzVyrk","wrapper":"VCJeT5","label":"xYGmQj"};